export function getBase64ImageFromURL(url: string) {
    return new Promise((resolve, reject) => {
        const img = new Image()

        img.setAttribute('crossOrigin', 'anonymous')

        img.onload = () => {
            const canvas = document.createElement('canvas')

            canvas.width = img.width
            canvas.height = img.height

            const ctx = canvas.getContext('2d')

            if (ctx === null) {
                reject('Failed to get canvas context')
                return
            }

            ctx.drawImage(img, 0, 0)

            const dataURL = canvas.toDataURL('image/png')

            resolve(dataURL)
        }

        img.onerror = (error: string | Event) => {
            reject(error)
        }

        img.src = url
    })
}
